import newIconTableInfoDataset from "../datasets/icon_table_info_dataset";

export const createIconTableObj = (iconName, newIconTable, additionalInfo, oldIconTable) => {
    let iconInfoObj = newIconTableInfoDataset.find(elem => elem.iconName === iconName);
    let iconIndx = newIconTable.findIndex(elem => elem.iconName === iconName);
    let oldIconIndx = -1;
    if (oldIconTable && oldIconTable.length > 0){
        oldIconIndx = oldIconTable.findIndex(elem => elem.iconName === iconName);
    }
    if (iconIndx === -1){
        let newIconTableObj = {};
        if (oldIconIndx === -1){
            // if iconName not already in the table then create new object  
            newIconTableObj = JSON.parse(JSON.stringify(iconInfoObj)); 
        }else{
            newIconTableObj = oldIconTable[oldIconIndx];
        }
        if (additionalInfo){
            newIconTableObj = {...newIconTableObj, additionalInfo: additionalInfo};
        }
        newIconTable.push(newIconTableObj);
    }else{
        // if iconName is found, add the new additionalInfo
        if (additionalInfo){
            if (additionalInfo.unlockedFeature === true){
                if (additionalInfo.level === newIconTable[iconIndx].additionalInfo.level){
                    //  this means the icon has already been for this unlocked feature/level
                }else{
                    newIconTable[iconIndx].firstTime = true;
                }
            }
            if (newIconTable[iconIndx].additionalInfo){
                newIconTable[iconIndx].additionalInfo = additionalInfo;
            }else{
                newIconTable[iconIndx] = {...newIconTable[iconIndx], additionalInfo:  additionalInfo};
            }
        }
    }

    return newIconTable;
   
}

export default createIconTableObj;





